import * as Sentry from '@sentry/angular';

import { APP_VERSION } from '../app/app-version';
import { environment } from '../environments/environment';

export function initializeSentry(): void {
  const enableSentry =
    environment.deploymentTarget === 'production' &&
    !globalThis.location.host.startsWith('localhost');

  Sentry.init({
    enabled: enableSentry,
    dsn: 'https://b45614f67e987a37f1127c9b728c357a@o4507101059350528.ingest.us.sentry.io/4507101091463168',
    normalizeDepth: 6,
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        colorScheme: 'system',
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
        networkDetailAllowUrls: [globalThis.location.origin, 'https://core.blaze.tech'],
        networkCaptureBodies: true,
      }),
    ],
    // Don't record & send replays by default, as they can consume a lot of quota.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    // Performance Monitoring
    tracesSampleRate: 0.75,
    tracePropagationTargets: [/^https:\/\/core\.blaze\.tech/],
    release: APP_VERSION,
  });

  if (enableSentry) {
    initializeSentryFeedback();
  }
}

function initializeSentryFeedback(): void {
  // Start buffering the replay without sending it to Sentry, so we don't use replays quota unnecessarily.
  Sentry.getReplay()?.startBuffering();

  document.addEventListener('keydown', async (event: KeyboardEvent) => {
    if (event.altKey && event.shiftKey && event.code === 'KeyI') {
      event.preventDefault();
      const feedback = Sentry.getFeedback();
      const form = await feedback?.createForm({ showBranding: false });
      form?.appendToDom();
      form?.open();
    }
  });
}
